import { render, staticRenderFns } from "./search-data-no-results.component.vue?vue&type=template&id=61eaa45f"
import script from "./search-data-no-results.component.vue?vue&type=script&lang=ts"
export * from "./search-data-no-results.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports